// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 250px;
    background: white;
}
.content {
    position: relative;
    overflow: auto;
    height: calc(100% - 50px);
    width: 100%;
}
.module-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}
.module {
    border: 1px solid gray;
    width: 300px;
    position: absolute;
    background: white;
}
.module-header {
    border: 1px solid gray;
    color: white;
    background: gray;
    height: 20px;
    cursor: grab;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    flex-direction: row;
    align-items:center;
}
.module-header-text {
    flex:1 1 auto;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}
.module-action{
    height:15px;
    width:15px;
    cursor:pointer;
}
.module-line {
    height: 20px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor:pointer;
    display:flex;
    flex-direction:row;
}
.module-line-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex:1 1 auto;
    padding-right:5px;
}
.menu-bar {
    border: 1px solid gray;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/erd/erd.settings.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,OAAO;AACX;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,UAAU;IACV,cAAc;AAClB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".zoom {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n    width: 250px;\n    background: white;\n}\n.content {\n    position: relative;\n    overflow: auto;\n    height: calc(100% - 50px);\n    width: 100%;\n}\n.module-wrapper {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n}\n.module {\n    border: 1px solid gray;\n    width: 300px;\n    position: absolute;\n    background: white;\n}\n.module-header {\n    border: 1px solid gray;\n    color: white;\n    background: gray;\n    height: 20px;\n    cursor: grab;\n    padding-left: 10px;\n    padding-right: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items:center;\n}\n.module-header-text {\n    flex:1 1 auto;\n    white-space:nowrap;\n    overflow:hidden;\n    text-overflow:ellipsis;\n}\n.module-action{\n    height:15px;\n    width:15px;\n    cursor:pointer;\n}\n.module-line {\n    height: 20px;\n    padding-left: 10px;\n    padding-right: 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor:pointer;\n    display:flex;\n    flex-direction:row;\n}\n.module-line-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex:1 1 auto;\n    padding-right:5px;\n}\n.menu-bar {\n    border: 1px solid gray;\n    height: 50px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
